<template>
    <div style="margin-top: 5px;">
        <el-empty v-show="list_detail.length == 0" :description="$t('lang.空')"></el-empty>
        <div v-show="list_detail.length > 0" :id="div_id" style="width: 100%;"></div>
    </div>
</template>

<script>
import HighCharts from "highcharts";
import dark from "highcharts/themes/dark-unica";
import exportHighChart from "highcharts/modules/exporting";
import exportOffHighChart from "highcharts/modules/offline-exporting";
exportHighChart(HighCharts);
exportOffHighChart(HighCharts);
dark(HighCharts);
export default {
    props: ["main", "list_detail", "div_id", "type"],
    data() {
        return {
        };
    },
    computed: {
        result_mL() {
            let that = this;
            if (that.main.jianCeDuiXiang == "ShuiNi") {
                if (that.main.shiYanLeiXing == "KongBai") {
                    return that.main.v_ShuiNi_KongBai;
                }
                else if (that.main.shiYanLeiXing == "LvHuaWu") {
                    return that.main.v_ShuiNi_LvHuaWu;
                }
                else if (that.main.shiYanLeiXing == "XiaoSuanYin") {
                    return that.main.v_ShuiNi_XiaoSuanYin;
                }
                else {
                    return 0;
                }
            }
            else if (that.main.jianCeDuiXiang == "WaiJiaJi") {
                if (that.main.shiYanLeiXing == "KongBai") {
                    if (that.type == "detail") {
                        return that.main.v_WaiJiaJi_KongBai_V01;
                    }
                    else {
                        return that.main.v_WaiJiaJi_KongBai_V02;
                    }
                }
                else if (that.main.shiYanLeiXing == "XiaoSuanYin") {
                    if (that.type == "detail") {
                        return that.main.v_WaiJiaJi_XiaoSuanYin_V001;
                    }
                    else {
                        return that.main.v_WaiJiaJi_XiaoSuanYin_V002;
                    }
                }
                else if (that.main.shiYanLeiXing == "LvHuaWu") {
                    if (that.type == "detail") {
                        return that.main.v_WaiJiaJi_LvHuaWu_V1;
                    }
                    else {
                        return that.main.v_WaiJiaJi_LvHuaWu_V2;
                    }
                }
                else {
                    return 0;
                }
            }
            else {
                return 0;
            }

        }
    },
    watch: {
        list_detail(v) {
            let that = this;
            that.loadChart(v);
        }
    },
    methods: {
        loadChart(v) {
            let that = this;
            if (v.length == 0) {
                return;
            }

            let mapData = [];
            mapData.push({ name: that.$t("lang.电势"), type: "line", yAxis: 0, data: [] });
            mapData.push({ name: that.$t("lang.电势") + "Δ", type: "line", yAxis: 1, data: [] });
            for (let i = 0; i < v.length; i++) {
                if (!v[i].paiYeTiJi || !v[i].rongYeDianShi) {
                    continue;
                }
                mapData[0].data.push([parseFloat(v[i].paiYeTiJi), parseFloat(v[i].rongYeDianShi)]);
            }
            for (let i = 0; i < v.length; i++) {
                if (!v[i].paiYeTiJi || !v[i].daiErTa) {
                    continue;
                }
                mapData[1].data.push([parseFloat(v[i].paiYeTiJi), parseFloat(v[i].daiErTa)]);
            }
            HighCharts.chart(that.div_id, {
                lang: {
                    viewFullscreen: that.$t("lang.全屏"),
                    printChart: that.$t("lang.打印图表"),
                    downloadJPEG: that.$t("lang.导出JPEG"),
                    downloadPDF: that.$t("lang.导出PDF"),
                    downloadPNG: that.$t("lang.导出PNG"),
                    downloadSVG: that.$t("lang.导出SVG"),
                },
                tooltip: {
                    formatter: function () {
                        console.log(this);
                        if (this.colorIndex == 0) {
                            return that.$t("lang.电势") + "(mV)：" + this.y + "<br />" + that.$t("lang.体积") + "(mL)：" + this.x;
                        }
                        else {
                            return that.$t("lang.电势") + "Δ(ΔmV)：" + this.y + "<br />" + that.$t("lang.体积") + "(mL)：" + this.x;
                        }
                    },
                },
                xAxis: {
                    title: {
                        text: that.$t("lang.体积") + "(mL)",
                    },
                    plotLines: [{
                        color: 'red',
                        width: 1,
                        value: that.result_mL,
                    }],
                },
                yAxis: [{
                    title: {
                        text: that.$t("lang.电势") + "(mV)",
                    },
                }, {
                    title: {
                        text: that.$t("lang.电势") + "Δ(ΔmV)",
                    },
                }],
                title: { text: that.main.shiYanBianHao },
                series: mapData,
                credits: {
                    enabled: false,
                },
                exporting: {
                    fallbackToExportServer: false,
                },
            });
        }
    },

    mounted() {

    }

};
</script>

<style></style>